import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  icon: {
    margin: "unset"
  }
}));

const CustomButton = styled(Button)(({ theme }) => ({
  borderRadius: "20px",
  color: "#c1c1c1",
  fontSize: "13px",
  textTransform: "none",
  backgroundColor: "transparent",
  fontWeight: "bold",
  padding: "10px",
  paddingRight: "20px",
  paddingLeft: "10px",
  border: "solid",
  borderColor: "#c1c1c1",
  borderWidth: "1px",
  minWidth: "0px",
  "&:hover": {
    boxShadow: "none",
  },
  boxShadow: "none",
}));

const YellowButton = styled(CustomButton)(({ theme }) => ({
  border: "none",
  backgroundColor: "#ddb930",
  "&:hover": {
    backgroundColor: "#ddb930",
  },
}));

type ImageProps = {
  type: any;
};

const ImageSButton = ({type}: ImageProps) => {
  const googleImg = require('assets/google.png');
  const twitterImg = require('assets/twitter.png');
  const controlImg = require('assets/control.png');
  const classes = useStyles();

  return type === "google" ? (
    <CustomButton
      variant="contained"
      endIcon={
        <img
          style={{ paddingRight: "5px", paddingLeft: "5px" }}
          src={googleImg}
          className={classes.icon}
          alt="google"
        />
      }
    ></CustomButton>
  ) : type === "control" ? (
    <YellowButton
      variant="contained"
      endIcon={
        <img
          src={controlImg}
          className={classes.icon}
          alt="control"
        />
      }
    ></YellowButton>
  ) : (
    <CustomButton variant="contained"
      endIcon={
        <img
          style={{ paddingRight: "10px", paddingLeft: "10px" }}
          src={twitterImg}
          className={classes.icon}
          alt="twitter"
        />
      }
    ></CustomButton>
  );
}


export default ImageSButton;
